module.exports = __webpack_public_path__ + "img/edmbet-support.0e90ca0a.png";